import React, { useState, useEffect } from "react";
import {
  parseCurrency,
  getAlert,
  getViewAp,
  getDataWithComp,
  insertData,
  updateData,
  useEscapeClose,
  getSpRunNumber,
} from "../../../utils/SamuiUtils";
import {
  formatThaiDateUiToDate,
  getCreateDateTime,
} from "../../../utils/DateUtils";
import { getKeyboardInstructions } from "../../../utils/ModalKeyboardNavigation";
import moment from "moment";
import ApModal from "./ApModal";
import PayModal from "./payModal.js";
import DatePicker from "../DatePicker.js";

const WtaxModal = ({
  showWTModal,
  handleWTClose,
  DataList,
  setTotalWT,
  setInputValueTotalWT,
  selectedOption,
  setSelectedOption,
  taxData,
  setTaxData,
  setTaxtotalAmount,
  formMasterList,
  setFormMasterList,
  docRef,
  Ref_PAY_ID,
  setDocRef,
  setRef_PAY_ID,
  mode,
  onSaved,
}) => {

  useEscapeClose(showWTModal, handleWTClose);

  useEffect(() => {
    initialize2();
  }, []);

  useEffect(() => {
    console.log("Updated formMasterList:", formMasterList);
  }, [formMasterList]);

  const getViewpay = async () => {
    try {
      const response = await getDataWithComp(
        "API_0401_PAY_H",
        `and IsWTAX='N' ORDER BY Pay_No desc`
      );
      return response;
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const initialize2 = async () => {
    try {
      const apDataList = await getViewAp();
      if (apDataList && apDataList.length > 0) {
        setApDataList(apDataList);
        // setFormMasterList(formMasterList)
      }
      const payDataList = await getViewpay();
      if (payDataList && payDataList.length > 0) {
        setpayDataList(payDataList);
      }
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };
  // const [formMasterList, setFormMasterList] = useState();

  const [apDataList, setApDataList] = useState([]);
  const [showApModal, setShowApModal] = useState(false);
  const handleApShow = () => setShowApModal(true);
  const handleApClose = () => setShowApModal(false);
  const onRowSelectAp = (apSelected) => {
    try {
      setFormMasterList({
        ...formMasterList,
        apID: apSelected.AP_Id,
        apCode: apSelected.AP_Code,
        apName: apSelected.AP_Name,
        apAdd1: apSelected.AP_Add1,
        apAdd2: apSelected.AP_Add2,
        apAdd3: apSelected.AP_Add3,
        apProvince: apSelected.AP_Province,
        apZipcode: apSelected.AP_Zipcode,
        apTaxNo: apSelected.AP_TaxNo,
      });
      handleApClose(); // ปิด modal หลังจากเลือก
    } catch (error) {
      getAlert("FAILED", error);
    }
  };

  const [payDataList, setpayDataList] = useState([]);
  const [showpayModal, setshowpayModall] = useState(false);
  const handleshowpay = () => setshowpayModall(true);
  const handlepayClose = () => setshowpayModall(false);
  const onRowSelectpay = (Selected) => {
    try {
      setFormMasterList({
        ...formMasterList,
        payId: Selected.Pay_Id,
        apID: Selected.AP_Id,
        apCode: Selected.AP_Code,
        apName: Selected.AP_Name,
        apAdd1: Selected.AP_Add1,
        apAdd2: Selected.AP_Add2,
        apAdd3: Selected.AP_Add3,
        apProvince: Selected.AP_Province,
        apZipcode: Selected.AP_Zipcode,
        apTaxNo: Selected.AP_TaxNo,
      });
      setDocRef(Selected.Pay_No);
      setRef_PAY_ID(Selected.Pay_No);
      handlepayClose();
    } catch (error) {
      getAlert("FAILED", error);
    }
  };

  const handleDateChange = (id, date) => {
    setTaxData((prev) =>
      prev.map((item) =>
        item.id === id
          ? { ...item, date: moment(date).format("YYYY/MM/DD") }
          : item
      )
    );
  };

  const totalAmount = taxData.reduce(
    (sum, item) => sum + parseCurrency(item.amount),
    0
  );
  const totalTax = taxData.reduce(
    (sum, item) => sum + parseCurrency(item.tax),
    0
  );

  const handlesave = async () => {
    if (!taxData[0].amount || taxData[0].amount <= 0) {
      getAlert("FAILED", "กรุณากรอกจำนวนเงินของรายการแรก");
      return;
    }

    if (window.location.pathname === "/payment-voucher") {
      const totalTax = await taxData.reduce(
        (sum, item) => sum + parseCurrency(item.tax),
        0
      );
      await setTotalWT(totalTax);
      await setInputValueTotalWT(
        totalTax.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      );
      await setTaxtotalAmount(totalAmount);
      handleWTClose();
    } else {
      if (mode === "U") {
        const dataTax = {
          Ref_PAY_ID: formMasterList.payId,
          AP_Id: formMasterList.apID,
          Ref_Doc: docRef,
          WTAX_Type: selectedOption,
          WTAX_Total: parseCurrency(totalAmount).toFixed(2),
          WTAX_Total_Tax: parseCurrency(totalTax).toFixed(2),
          WTAX_Updated_Date: formatThaiDateUiToDate(getCreateDateTime()),
          WTAX_Updated_By: window.localStorage.getItem("name"),
          WTAX_Status: 1,
        };

        const dataTaxD = {
          WTAX_Desc: taxData[0]?.remark,
          WTAX_Percent: taxData[0]?.percent,
          WTAX_Pay: parseCurrency(totalAmount).toFixed(2),
          WTAX_Tax: parseCurrency(totalTax).toFixed(2),
          WTAX_TypeNo: taxData[0]?.type,
          WTax_Date: moment(taxData[0].date).toDate(),
        };

        await updateData("WTAX_H", dataTax, {
          WTAX_Id: `${taxData[0]?.Wtax_Id}`,
        });
        await updateData("WTAX_D", dataTaxD, {
          WTAX_Id: `${taxData[0]?.Wtax_Id}`,
        });
        handleWTClose();
        if (typeof onSaved === "function") {
          onSaved();
        } else {
          window.location.reload();
        }
      } else {
        const validTaxData = taxData.filter(
          (item) => parseCurrency(item.amount) > 0
        );
        if (validTaxData.length === 0) {
          getAlert("FAILED", "ไม่มีข้อมูลที่สามารถสร้าง WTAX_H ได้");
          return;
        }
        for (const taxItem of validTaxData) {
          const getYearMonthFromDate = (dateStr) => {
            if (!dateStr) return undefined;
            const formats = [
              "DD/MM/YYYY",
              "YYYY/MM/DD",
              "DD-MM-YYYY",
              "YYYY-MM-DD",
              "MM/DD/YYYY",
            ];
            let m = moment(dateStr, formats, true);
            if (!m.isValid()) {
              m = moment(dateStr);
              if (!m.isValid()) return undefined;
            }
            let year = m.year();
            if (year < 2500) year = year + 543;
            const yy = year.toString().slice(-2);
            const mm = (m.month() + 1).toString().padStart(2, "0");
            return `${yy}${mm}`;
          };

          const yearmonth = getYearMonthFromDate(taxItem.date);
          const newWTaxNo = await getSpRunNumber("WT", yearmonth);

          const wtaxHData = {
            WTax_No: newWTaxNo,
            Ref_PAY_ID: formMasterList.payId,
            AP_Id: formMasterList.apID,
            Ref_Doc: docRef,
            WTax_Type: selectedOption,
            WTax_Total: parseCurrency(taxItem.amount).toFixed(2), // ทศนิยมเข้า DB
            WTax_Total_Tax: parseCurrency(taxItem.tax).toFixed(2),
            WTax_Created_Date: moment().add(7, "hours").toDate(),
            WTax_Created_By: window.localStorage.getItem("name"),
            WTax_Updated_Date: null,
            WTax_Updated_By: null,
            Comp_Id: window.localStorage.getItem("company"),
            WTAX_Status: 1,
          };

          const insertWtaxHRes = await insertData(
            "WTAX_H",
            Object.keys(wtaxHData).join(", "),
            Object.values(wtaxHData)
          );

          if (insertWtaxHRes?.status !== "OK") {
            getAlert(
              "FAILED",
              "ไม่สามารถบันทึกข้อมูลภาษีหัก ณ ที่จ่าย (WTAX_H) ได้"
            );
            return;
          }

          // ดึง WTAX_Id ที่สร้างขึ้น
          const getWtaxIdResponse = await getDataWithComp(
            "WTAX_H",
            `And WTax_No = '${newWTaxNo}'`
          );

          if (!getWtaxIdResponse || getWtaxIdResponse.length === 0) {
            getAlert("FAILED", "ไม่พบ WTax_Id ที่ถูกสร้างขึ้น");
            return;
          }

          const wtaxId = getWtaxIdResponse[0].WTAX_Id;

          // บันทึก WTAX_D สำหรับ WTAX_H แต่ละใบ
          const wtaxDData = {
            WTax_Id: wtaxId,
            WTax_TypeNo: taxItem.type,
            WTax_Desc: taxItem.remark || "",
            WTax_Percent: parseCurrency(taxItem.percent),
            WTax_Date: moment(taxItem.date, "DD/MM/YYYY")
              .add(7, "hours")
              .toDate(),
            WTax_Pay: parseFloat(parseCurrency(taxItem.amount)).toFixed(2),
            WTax_Tax: parseFloat(parseCurrency(taxItem.tax)).toFixed(2),
          };

          const insertWtaxDRes = await insertData(
            "WTAX_D",
            Object.keys(wtaxDData).join(", "),
            Object.values(wtaxDData)
          );

          if (insertWtaxDRes?.status !== "OK") {
            getAlert("FAILED", "ไม่สามารถบันทึกข้อมูล WTAX_D ได้");
            return;
          }
        }
        const Total_WT = {
          Total_WT: (totalTax || 0).toFixed(2),
        };
        await updateData("PAY_H", Total_WT, { Pay_Id: formMasterList.payId });

        setFormMasterList([]);
        setRef_PAY_ID();
        setDocRef();
        const currentDate = moment().add(543, "years").format("DD/MM/YYYY");
        setTaxData([
          {
            id: 1,
            type: 5,
            percent: 3.0,
            date: currentDate,
            amount: 0.0,
            tax: 0.0,
            remark: "",
          },
          {
            id: 2,
            type: 6,
            percent: 3.0,
            date: currentDate,
            amount: 0.0,
            tax: 0.0,
            remark: "",
          },
        ]);
        handleWTClose();
        if (typeof onSaved === "function") {
          onSaved();
        } else {
          window.location.reload();
        }
      }
    }
  };

  const calculateTotals = (data) => {
    const totalAmount = data.reduce(
      (sum, item) => sum + (parseCurrency(item.amount) || 0),
      0
    );
    const totalTax = data.reduce(
      (sum, item) => sum + (parseCurrency(item.tax) || 0),
      0
    );
    return { totalAmount, totalTax };
  };

  const handleDropdownChange = (id, field, value) => {
    const updatedList = taxData.map((item) => {
      if (item.id === id) {
        const newValue =
          field === "percent" ? parseCurrency(value) || 0 : value;
        const newTax =
          field === "percent"
            ? (parseCurrency(item.amount) || 0) * (newValue / 100)
            : item.tax;
        return { ...item, [field]: newValue, tax: newTax };
      }
      return item;
    });

    setTaxData(updatedList);
    const { totalAmount, totalTax } = calculateTotals(updatedList);
  };

  const handleChangeDetail = (index, field, value) => {
    // อนุญาตให้กรอกตัวเลขและทศนิยมได้อย่างอิสระ
    if (!/^\d*\.?\d{0,2}$/.test(value)) {
      return;
    }

    const updatedList = [...taxData];
    updatedList[index][field] = value;

    if (field === "amount") {
      const amount = parseFloat(value) || 0;
      const percent = parseFloat(updatedList[index].percent) || 0;
      updatedList[index].tax = (amount * percent) / 100;
    }

    setTaxData(updatedList);
  };

  const formatNumber = (num) => {
    return num
      ? num.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
      : "0.00";
  };
  const handleFocus = (index, field) => {
    const updatedList = [...taxData];
    updatedList[index][field] = updatedList[index][field]
      .toString()
      .replace(/,/g, "");
    setTaxData(updatedList);
  };

  const handleBlur = (index, field, value) => {
    let numericValue = parseFloat(value.replace(/,/g, "")) || 0;
    const formattedValue = numericValue.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    const updatedList = [...taxData];
    updatedList[index][field] = formattedValue;
    setTaxData(updatedList);
  };
  return (
    <>
      <div
        className={`modal ${showWTModal ? "show" : ""}`}
        style={{ display: showWTModal ? "block" : "none" }}
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content" style={{ width: "1000px" }}>
            <div className="modal-header">
              <div className="d-flex align-items-center">
                <h5 className="modal-title">ใบภาษีหัก ณ ที่จ่าย</h5>
                {window.location.pathname === "/payment-voucher" ? null : (
                  <h5
                    className="modal-title"
                    style={{ color: "red", marginLeft: "10px" }}
                  >
                    {taxData[0]?.Wtax_No || ""}
                  </h5>
                )}
              </div>

              <button type="button" className="close" onClick={handleWTClose}>
                <span>&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div>
                <div className="mb-2">
                  <div className="d-flex align-items-center">
                    <label>ผู้ขาย</label>
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control input-spacing"
                        name="apCode"
                        value={
                          window.location.pathname === "/payment-voucher"
                            ? (formMasterList[0]?.apCode || "") +
                            " " +
                            (formMasterList[0]?.apName || "")
                            : (formMasterList?.apCode || "") +
                            " " +
                            (formMasterList?.apName || "")
                        }
                        // onChange={handleChangeMaster}
                        disabled={true}
                      />
                      {window.location.pathname === "/payment-voucher" ? (
                        <button
                          className="btn btn-outline-secondary"
                          onClick={handleApShow}
                          disabled={
                            window.location.pathname === "/payment-voucher"
                          }
                        >
                          <i className="fas fa-search"></i>
                        </button>
                      ) : (
                        <button
                          className="btn btn-outline-secondary"
                          onClick={handleApShow}
                          disabled={
                            mode === "U" && Ref_PAY_ID !== null ? true : false
                          }
                        >
                          <i className="fas fa-search"></i>
                        </button>
                      )}
                    </div>
                  </div>
                  <ApModal
                    showApModal={showApModal}
                    handleApClose={handleApClose}
                    apDataList={apDataList}
                    onRowSelectAp={onRowSelectAp}
                  />
                </div>

                <div className="d-flex align-items-center mb-2">
                  <label>ที่อยู่</label>
                  <input
                    type="text"
                    className="form-control input-spacing"
                    name="apAdd1"
                    value={
                      window.location.pathname === "/payment-voucher"
                        ? formMasterList[0]?.apAdd1 || ""
                        : formMasterList?.apAdd1 || ""
                    }
                    // onChange={handleChangeMaster}
                    disabled={true}
                  />
                </div>

                <div className="d-flex align-items-center mb-2">
                  <label></label>
                  <input
                    type="text"
                    className="form-control input-spacing"
                    value={
                      window.location.pathname === "/payment-voucher"
                        ? (formMasterList[0]?.apAdd2 || "") +
                        " " +
                        (formMasterList[0]?.apAdd3 || "")
                        : (formMasterList?.apAdd2 || "") +
                        " " +
                        (formMasterList?.apAdd3 || "")
                    }
                    disabled={true}
                  />
                </div>

                <div className="d-flex align-items-center mb-2">
                  <label></label>
                  <input
                    type="text"
                    className="form-control input-spacing"
                    value={
                      window.location.pathname === "/payment-voucher"
                        ? (formMasterList[0]?.apProvince || "") +
                        " " +
                        (formMasterList[0]?.apZipcode || "")
                        : (formMasterList?.apProvince || "") +
                        " " +
                        (formMasterList?.apZipcode || "")
                    }
                    disabled={true}
                  />
                </div>

                <div className="d-flex align-items-center mb-2">
                  <label>เลขที่ภาษี</label>
                  <input
                    type="text"
                    className="form-control input-spacing"
                    value={
                      window.location.pathname === "/payment-voucher"
                        ? formMasterList[0]?.apTaxNo || ""
                        : formMasterList?.apTaxNo || ""
                    }
                    disabled={true}
                  />
                </div>
              </div>
              <div className="d-flex align-items-center mb-2">
                <label className="form-label">เลือกแบบ</label>
                <select
                  className="form-control"
                  value={selectedOption}
                  onChange={(e) => setSelectedOption(e.target.value)}
                >
                  <option value={1}>(1) ภ.ง.ด.1ก.</option>
                  <option value={2}>(2) ภ.ง.ด.1ก.พิเศษ</option>
                  <option value={3}>(3) ภ.ง.ด.2</option>
                  <option value={4}>(4) ภ.ง.ด.3</option>
                  <option value={5}>(5) ภ.ง.ด.2ก.</option>
                  <option value={6}>(6) ภ.ง.ด.3ก.</option>
                  <option value={7}>(7) ภ.ง.ด.53</option>
                </select>
              </div>
              <div className="d-flex mb-2">
                <label className="form-label">ใบสำคัญจ่าย</label>
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control input-spacing"
                    value={Ref_PAY_ID || ""}
                    onChange={(e) => setRef_PAY_ID(e.target.value)}
                    disabled={true}
                  />
                  {window.location.pathname === "/payment-voucher" ? (
                    <button
                      className="btn btn-outline-secondary"
                      onClick={handleshowpay}
                      disabled={window.location.pathname === "/payment-voucher"}
                    >
                      <i className="fas fa-search"></i>
                    </button>
                  ) : (
                    <button
                      className="btn btn-outline-secondary"
                      onClick={handleshowpay}
                      disabled={
                        mode === "U" && Ref_PAY_ID !== null ? true : false
                      }
                    >
                      <i className="fas fa-search"></i>
                    </button>
                  )}
                </div>
                <PayModal
                  showpayModal={showpayModal}
                  handlepayClose={handlepayClose}
                  payDataList={payDataList}
                  onRowSelectpay={onRowSelectpay}
                />
              </div>
              <div className="d-flex mb-2">
                <label className="form-label">เอกสารอ้างอิง</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  value={docRef || ""}
                  onChange={(e) => setDocRef(e.target.value)}
                  disabled={
                    window.location.pathname === "/payment-voucher"
                      ? true
                      : false
                  }
                />
              </div>

              <table className="table table-striped table-hover">
                <thead className="thead-dark">
                  <tr className="table-header bg-warning text-white">
                    <th className="text-center">ประเภทเงินได้ที่จ่าย</th>
                    <th className="text-center">รายละเอียด</th>
                    <th className="text-center" style={{ width: "100px" }}>
                      % ที่หัก
                    </th>
                    <th className="text-center" style={{ width: "130px" }}>
                      วัน/เดือน/ปี
                    </th>
                    <th className="text-center" style={{ width: "150px" }}>
                      จำนวนเงินที่จ่าย
                    </th>
                    <th className="text-center" style={{ width: "100px" }}>
                      ภาษีที่หักไว้
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {taxData.map((row, index) => (
                    <tr key={row.id}>
                      <td>
                        <select
                          className="form-control"
                          value={row.type}
                          onChange={(e) =>
                            handleDropdownChange(row.id, "type", e.target.value)
                          }
                        >
                          <option value={1}>
                            1.เงินเดือน ค่าจ้าง โบนัส ฯลฯ ตามมาตรา 40(1)
                          </option>
                          <option value={2}>
                            2.ค่าธรรมเนียม ค่านายหน้า ฯลฯ ตามมาตรา 40(2)
                          </option>
                          <option value={3}>
                            3.ค่าแห่งลิขสิทธิ ฯลฯ ตามมาตรา 40(3)
                          </option>
                          <option value={4}>
                            4.(ก) ค่าดอกเบีย ฯลฯ ตามมาตรา 40(4) (ก)
                          </option>
                          <option value={5}>
                            5.การจ่ายเงินได้ทีต้องหักภาษี ณ
                            ทีจ่ายตามคําสังสรรพากรทีออก
                          </option>
                          <option value={6}>6.อื่นๆ ระบุ</option>
                        </select>
                      </td>
                      <td>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <input
                            type="text"
                            className="form-control"
                            value={row.remark || ""}
                            onFocus={(e) => (e.target.value = "")}
                            onBlur={(e) =>
                              handleDropdownChange(
                                row.id,
                                "remark",
                                e.target.value || row.remark
                              )
                            }
                            onChange={(e) =>
                              handleDropdownChange(
                                row.id,
                                "remark",
                                e.target.value
                              )
                            }
                          />
                        </div>
                      </td>
                      <td>
                        <select
                          className="form-control"
                          value={row.percent}
                          onChange={(e) =>
                            handleDropdownChange(
                              row.id,
                              "percent",
                              e.target.value
                            )
                          }
                        >
                          <option value="1">1.00</option>
                          <option value="2">2.00</option>
                          <option value="3">3.00</option>
                          <option value="5">5.00</option>
                        </select>
                      </td>
                      <DatePicker
                        label="วันที่"
                        name=""
                        value={row.date}
                        onChange={(date) => handleDateChange(row.id, date)}
                        disabled={false}
                      />
                      <td>
                        <input
                          type="text"
                          className="form-control text-end"
                          value={formatNumber(row.amount) || ""}
                          onChange={(e) =>
                            handleChangeDetail(index, "amount", e.target.value)
                          }
                          onFocus={(e) => handleFocus(index, "amount")}
                          onBlur={(e) =>
                            handleBlur(index, "amount", e.target.value)
                          }
                        />
                      </td>
                      <td className="text-end">{formatNumber(row.tax)}</td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr className="bg-light font-weight-bold">
                    <td colSpan="4" className="text-right">
                      รวมเงินที่จ่ายและภาษีที่หักนําส่ง
                    </td>
                    <td className="text-end">{formatNumber(totalAmount)}</td>
                    <td className="text-end">{formatNumber(totalTax)}</td>
                  </tr>
                </tfoot>
              </table>
            </div>
            <div className="modal-footer">
              <div className="text-left" style={{ fontSize: "12px", color: "#666", marginRight: "auto" }}>
                {getKeyboardInstructions('wtax')}
              </div>
              <button className="btn btn-danger" onClick={handleWTClose}> ปิด (ESC)</button>
              <button className="btn btn-primary" onClick={handlesave}>
                บันทึก
              </button>
            </div>
          </div>
        </div>
      </div>
      {showWTModal && <div className="modal-backdrop fade show"></div>}
    </>
  );
};

export default WtaxModal;
